module.exports = __webpack_public_path__ + "img/lume.271fca98.png";